import React, { FC, useState } from "react";
import { ButtonLink } from "@components/ui/Button";
import { City, Country } from "@graphql/types";
import { Close } from "@components/ui/Icon/icons/Close";

type IPostProps = {
  title: string;
  city?: Pick<City, "id" | "name" | "slug"> | null;
  country?: Pick<Country, "id" | "name" | "url"> | null;
};

type IProps = {
  post?: IPostProps;
};

const BlogPlanYourTripAd: FC<IProps> = ({ post }) => {
  const [showBlogAd, setShowBlogAd] = useState(true);

  const redirectUrlBlogCta = post?.city?.name
    ? `/s?city=${post.city.slug}&t=guides`
    : post?.country?.url
      ? `${post.country.url}/guides`
      : "/destinations";

  const utmSeparator = redirectUrlBlogCta.includes("?") ? "&" : "?";
  const utmParams = `${utmSeparator}utm_medium=post&utm_source=blog-cta`;

  return (
    showBlogAd && (
      <div className="hidden md:flex justify-center sticky top-screen-minus-335 bottom-16 mr-auto w-56 px-6 bg-blog-cta-background-v4 bg-cover text-white max-h-80 py-4">
        <Close
          className="h-4 w-4 text-white absolute top-1 left-1 cursor-pointer"
          onClick={() => setShowBlogAd(false)}
        />
        <div className="flex flex-col w-full relative">
          <ButtonLink
            size="xs"
            className="w-full text-white whitespace-nowrap absolute bottom-1"
            variant="blog-cta-v4"
            href={`${redirectUrlBlogCta}${utmParams}`}
            title="GoWithGuide-Find your guide"
          >
            Find your guide
          </ButtonLink>
        </div>
      </div>
    )
  );
};

export default BlogPlanYourTripAd;
